import { getDirectiongetRatio, getDirectionDetail, drectionAggregateExport, updateFile } from '@/services/locationFrequency';
import { siteTypeCode, transformArray, getDate } from '../../enum';
import { InitOrganizationAuth } from '@/services/area';
import { message } from 'antd';
import { isAreaData } from '@/services/area';
import { getToDay } from '@/utils/date';
import moment from 'moment';

let [startDate] = getToDay();
export default {

  namespace: 'directionLocationFrequency',
  state: {
    auth: {},
    searchParams: {
      ofDate: getDate(),
      flowType: 10,
      operationSiteType: 1
    },
    //基准日期，根据ofDate在查询时变动
    baseDate: moment(startDate).subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
    access: InitOrganizationAuth(),
    // 干线折线图
    ratioData: [],
    // 干线详情
    dataSource: [],
    // 干线导出
    exportData: [],
  },
  effects: {
    *getRatio(_, { call, put, select }) {
      let { searchParams, baseDate, auth } = yield select(({ directionLocationFrequency }) => directionLocationFrequency);
      const isDepartureArea = yield Promise.resolve(isAreaData(searchParams?.departureCenter?.code));
      const isArrivalArea = yield Promise.resolve(isAreaData(searchParams?.arrivalCenter?.code));
      const params = {
        ofDate: searchParams.ofDate,
        productType: searchParams.productType,
        flowType: searchParams.flowType,
        operationSiteType: searchParams.operationSiteType || "",
      };
      if (isDepartureArea) {
        params.provinceAreaCode = searchParams?.departureCenter?.code;
      } else {
        params.operationSiteCode = searchParams?.departureCenter?.code;
      }
      if (isArrivalArea) {
        params.nextProvinceAreaCode = searchParams?.arrivalCenter?.code;
      } else {
        params.nextSiteCode = searchParams?.arrivalCenter?.code;
      }
      const { code, data } = yield call(getDirectiongetRatio, params);
      if (code === 1) {
        const dataSource = transformArray(data || []);
        yield put({
          type: 'update',
          payload: {
            ratioData: dataSource,
          },
        });
      }
    },
    *getDetail(_, { call, put, select }) {
      let { searchParams, baseDate, auth } = yield select(({ directionLocationFrequency }) => directionLocationFrequency);
      const isDepartureArea = yield Promise.resolve(isAreaData(searchParams?.departureCenter?.code));
      const isArrivalArea = yield Promise.resolve(isAreaData(searchParams?.arrivalCenter?.code));
      const params = {
        ofDate: searchParams.ofDate,
        productType: searchParams.productType,
        flowType: searchParams.flowType,
        operationSiteType: searchParams.operationSiteType || "",
      };
      if (isDepartureArea) {
        params.provinceAreaCode = searchParams?.departureCenter?.code;
      } else {
        params.operationSiteCode = searchParams?.departureCenter?.code;
      }
      if (isArrivalArea) {
        params.nextProvinceAreaCode = searchParams?.arrivalCenter?.code;
      } else {
        params.nextSiteCode = searchParams?.arrivalCenter?.code;
      }
      let { code, data } = yield call(getDirectionDetail, params);
      if (code === 1) {
        // console.log("详情");
        const datas = data?.map(item => {
          if (item.name) {
            item.provinceFlowName = item.name;
          }
          return item;
        })
        yield put({
          type: 'update',
          payload: {
            dataSource: datas,
            exportData: datas,
          },
        });
        yield put({
          type: 'update',
          payload: { baseDate: searchParams.ofDate }
        });

      }
    },

    *export({ payload }, { call, put, select }) {
      let { searchParams, baseDate, auth } = yield select(({ directionLocationFrequency }) => directionLocationFrequency);
      const isDepartureArea = yield Promise.resolve(isAreaData(searchParams?.departureCenter?.code));
      const isArrivalArea = yield Promise.resolve(isAreaData(searchParams?.arrivalCenter?.code));
      const params = {
        ofDate: searchParams.ofDate,
        productType: searchParams.productType,
        flowType: searchParams.flowType,
        operationSiteType: searchParams.operationSiteType || "",
      };
      if (isDepartureArea) {
        params.provinceAreaCode = searchParams?.departureCenter?.code;
      } else {
        params.operationSiteCode = searchParams?.departureCenter?.code;
      }
      if (isArrivalArea) {
        params.nextProvinceAreaCode = searchParams?.arrivalCenter?.code;
      } else {
        params.nextSiteCode = searchParams?.arrivalCenter?.code;
      }
      const result = yield call(drectionAggregateExport, params);
      if (result && result.code === 1) {
        message.success('导出成功');
      }
    },
    *updateFile({ payload }, { call, put, select }) {
      let { searchParams, auth } = yield select(({ lineLocationFrequency }) => lineLocationFrequency);
      const formData = new FormData();
      formData.append('file', payload.sheet2blob, payload.fileName + ".xlsx");
      formData.append('pageName', payload.pageName);
      // delete params.organizationName;
      const result = yield call(updateFile, formData);
      if (result && result.code === 1) {
        message.success('导出成功');
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};
